import React, { ReactChild } from 'react'

export const LoginAlert = ({error, header , text }:Props) => {
    return(
        <div className={`rounded-sm p-3 fixed md:top-3 md:right-4 ${error ? " bg-red-100 " : " bg-green-100 "  } max-w-lg`}>
            <div className={`font-semibold ${error ? "text-red-600 " : " text-green-600 "  }`}>{header}</div>
            <div className='font-light text-sm'>
                {text}
            </div>
        </div>
    )
}

interface Props {
    error?:boolean
    header:string
    text:ReactChild
}